/* BEK Video-Hero mit Playlist (Claude, 2026-09-16) */
(function () {
  'use strict';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var ua = navigator.userAgent;
  var isSafari = /^((?!chrome|chromium|crios|android|edg).)*safari/i.test(ua);
  /* a11y (Claude, 2026-09-28): einzige Quelle ist html.bek-reduce-motion (setzt snippets/bek-a11y-head auch bei System-Einstellung) */
  var reduceMotion = document.documentElement.classList.contains('bek-reduce-motion');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var testV = document.createElement('video');
  var canVp9 = !isSafari && !!testV.canPlayType && testV.canPlayType('video/webm; codecs="vp9"') !== '';

  function VideoHero(root) {
    this.root = root;
    this.stage = root.querySelector('[data-vh-stage]');
    this.media = root.querySelector('.bek-vh__media');
    this.video = root.querySelector('[data-vh-video]');
    this.posters = Array.prototype.slice.call(root.querySelectorAll('.bek-vh__poster'));
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-vh-item]'));
    this.list = root.querySelector('[data-vh-list]');
    this.nowEl = root.querySelector('[data-vh-now]');
    this.countEl = root.querySelector('[data-vh-count]');
    this.cta = root.querySelector('[data-vh-cta]');
    this.ctaLabel = root.querySelector('[data-vh-cta-label]');
    this.btnToggle = root.querySelector('[data-vh-toggle]');
    this.btnMute = root.querySelector('[data-vh-mute]');
    this.index = 0;
    this.loaded = -1;
    /* teaser = kurzer stummer Vorschau-Clip (klein), full = ganzes Video mit Ton */
    this.mode = 'teaser';
    this.fsMode = false;
    this.visible = false;
    this.userPaused = false;
    this.userStarted = false;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion && !saveData;
    this.raf = 0;
    this.switchTimer = 0;
    if (!this.video || !this.items.length) return;
    this.bind();
    this.measureTop();
    this.observe();
  }

  VideoHero.prototype.measureTop = function () {
    var root = this.root;
    function m() {
      var top = root.getBoundingClientRect().top + window.scrollY;
      if (top < 20) {
        var hd = document.querySelector('.site-header, #SiteHeader, header');
        if (hd) top = hd.getBoundingClientRect().bottom + window.scrollY;
      }
      root.style.setProperty('--bek-vh-top', Math.max(0, Math.round(top)) + 'px');
    }
    m();
    /* Header-Höhe steht oft erst nach dem Laden fest (Sticky-Header, Ankündigungsleiste) */
    window.addEventListener('load', m);
    setTimeout(m, 600);
    setTimeout(m, 2000);
    window.addEventListener('resize', function () { requestAnimationFrame(m); });
  };

  VideoHero.prototype.bigScreen = function (full) {
    var dpr = window.devicePixelRatio || 1;
    var w = full ? Math.max(window.screen.width || 0, window.innerWidth) : this.stage.getBoundingClientRect().width;
    return !saveData && w * dpr > 1400;
  };

  VideoHero.prototype.hasTeaser = function (item) {
    return !!(item.getAttribute('data-t1080m') || item.getAttribute('data-t720m'));
  };

  VideoHero.prototype.teaserSrc = function (item) {
    var big = this.bigScreen(false);
    var webm = canVp9 && !item.__webmFailed;
    var order = big ? ['1080', '720'] : ['720', '1080'];
    for (var k = 0; k < order.length; k++) {
      var r = order[k];
      var u = (webm && item.getAttribute('data-t' + r + 'w')) || item.getAttribute('data-t' + r + 'm');
      if (u) return u;
    }
    return '';
  };

  VideoHero.prototype.fullSrc = function (item) {
    var hls = item.getAttribute('data-src-hls');
    if (hls && isSafari && this.video.canPlayType('application/vnd.apple.mpegurl')) return hls;
    var hd = item.getAttribute('data-src-hd');
    var sd = item.getAttribute('data-src-sd');
    if (this.bigScreen(true) || item.__sdFailed) return hd || sd;
    /* Shopify gibt per Liquid nur die 1080p-Datei heraus; die 720p-Stufe liegt mit festem Namensschema daneben */
    if ((!sd || sd === hd) && hd) sd = hd.replace(/HD-1080p-[0-9.]+Mbps/, 'HD-720p-1.6Mbps');
    return sd || hd;
  };

  VideoHero.prototype.src = function (item) {
    if (this.mode === 'teaser' && this.hasTeaser(item)) return this.teaserSrc(item);
    return this.fullSrc(item);
  };

  VideoHero.prototype.setMode = function (m) {
    if (this.mode === m) return;
    this.mode = m;
    this.loaded = -1;
    this.root.classList.toggle('is-full', m === 'full');
  };

  VideoHero.prototype.load = function (i) {
    if (this.loaded === i) return;
    var item = this.items[i];
    var url = this.src(item);
    if (!url) return;
    this.video.classList.remove('is-ready');
    this.video.setAttribute('aria-label', item.getAttribute('data-label') || '');
    this.video.preload = this.mode === 'teaser' ? 'auto' : 'metadata';
    this.video.src = url;
    this.setCaptions(item);
    this.video.load();
    this.loaded = i;
  };

  /* a11y (Claude, 2026-09-28): Untertitel (VTT) nur fuer das ganze Video mit Ton, wenn im Block gesetzt */
  VideoHero.prototype.setCaptions = function (item) {
    var v = this.video;
    Array.prototype.slice.call(v.querySelectorAll('track')).forEach(function (t) { t.parentNode.removeChild(t); });
    var vtt = item.getAttribute('data-captions');
    if (!vtt || this.mode !== 'full') { v.removeAttribute('crossorigin'); return; }
    v.crossOrigin = 'anonymous';
    var tr = document.createElement('track');
    tr.kind = 'captions';
    tr.srclang = 'de';
    tr.label = 'Deutsch';
    tr.src = vtt;
    tr.default = true;
    v.appendChild(tr);
  };

  VideoHero.prototype.play = function () {
    var self = this;
    this.load(this.index);
    var p = this.video.play();
    if (p && p.catch) {
      p.catch(function () {
        /* Autoplay blockiert (z. B. iOS-Stromsparmodus): Standbild bleibt, Play-Button zeigt Start */
        self.root.classList.remove('is-playing');
      });
    }
  };

  VideoHero.prototype.pause = function () { this.video.pause(); };

  VideoHero.prototype.setProgress = function (i, p) {
    var bar = this.items[i] && this.items[i].querySelector('[data-vh-bar]');
    if (bar) bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)) + ')';
  };

  VideoHero.prototype.tick = function () {
    var self = this;
    cancelAnimationFrame(this.raf);
    function loop() {
      var v = self.video;
      if (v.duration) self.setProgress(self.index, v.currentTime / v.duration);
      if (!v.paused && !v.ended) self.raf = requestAnimationFrame(loop);
    }
    this.raf = requestAnimationFrame(loop);
  };

  VideoHero.prototype.go = function (i, opts) {
    opts = opts || {};
    var n = this.items.length;
    i = (i + n) % n;
    var self = this;
    var prev = this.index;
    var wasPlaying = !this.video.paused || opts.play;
    if (i === prev && this.loaded === i) {
      if (opts.play) this.play();
      return;
    }
    this.index = i;

    this.items.forEach(function (el, k) {
      var on = k === i;
      el.classList.toggle('is-active', on);
      if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
    });
    this.setProgress(prev, 0);
    this.setProgress(i, 0);
    this.posters.forEach(function (img, k) {
      if (k === i && img.loading === 'lazy') img.loading = 'eager';
      img.classList.toggle('is-active', k === i);
    });

    var item = this.items[i];
    if (this.nowEl) this.nowEl.textContent = item.getAttribute('data-title') || '';
    if (this.countEl) this.countEl.textContent = pad(i + 1) + ' / ' + pad(n);
    if (this.cta) {
      var url = item.getAttribute('data-url');
      if (url) { this.cta.href = url; this.cta.hidden = false; } else { this.cta.hidden = true; }
      if (this.ctaLabel) this.ctaLabel.textContent = item.getAttribute('data-cta') || 'Modell ansehen';
    }

    /* aktiven Balken in der Handy-Leiste sichtbar machen */
    if (this.list && this.list.scrollWidth > this.list.clientWidth && opts.scroll !== false) {
      this.list.scrollTo({ left: item.offsetLeft - 16, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    /* Video ausblenden, Poster-Überblendung läuft, dann Quelle tauschen */
    this.video.classList.remove('is-ready');
    clearTimeout(this.switchTimer);
    this.switchTimer = setTimeout(function () {
      self.video.pause();
      self.loaded = -1;
      if (wasPlaying && self.visible) {
        self.play();
      } else {
        /* nicht laden, Standbild reicht bis zum Klick */
        self.video.removeAttribute('src');
        self.video.load();
      }
    }, reduceMotion ? 0 : 380);
  };

  VideoHero.prototype.startWithSound = function () {
    this.userStarted = true;
    this.userPaused = false;
    this.setMode('full');
    this.video.muted = false;
    this.root.classList.add('is-sound');
    this.play();
    this.updateMuteLabel();
  };

  VideoHero.prototype.updateMuteLabel = function () {
    var muted = this.video.muted;
    this.root.classList.toggle('is-sound', !muted);
    if (this.btnMute) this.btnMute.setAttribute('aria-label', muted ? 'Ton einschalten' : 'Ton ausschalten');
  };

  VideoHero.prototype.fullscreen = function () {
    var st = this.stage, v = this.video;
    var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
    if (fsEl) {
      (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      return;
    }
    /* Vollbild = bewusst ansehen: mit Ton abspielen (Klick erlaubt Ton) */
    this.userStarted = true;
    this.userPaused = false;
    this.fsMode = true;
    this.setMode('full');
    v.muted = false;
    this.video.classList.remove('is-ready');
    this.play();
    if (st.requestFullscreen) { st.requestFullscreen().catch(function () {}); }
    else if (st.webkitRequestFullscreen) { st.webkitRequestFullscreen(); }
    else if (v.webkitEnterFullscreen) {
      /* iPhone: nur das Video selbst kann Vollbild (braucht geladene Metadaten) */
      try { v.webkitEnterFullscreen(); }
      catch (e) { v.addEventListener('loadedmetadata', function () { try { v.webkitEnterFullscreen(); } catch (e2) {} }, { once: true }); }
    }
  };

  VideoHero.prototype.bind = function () {
    var self = this, v = this.video, root = this.root;

    v.addEventListener('playing', function () {
      v.classList.add('is-ready');
      root.classList.add('is-playing');
      if (self.btnToggle) self.btnToggle.setAttribute('aria-label', 'Video pausieren');
      self.tick();
    });
    v.addEventListener('pause', function () {
      root.classList.remove('is-playing');
      if (self.btnToggle) self.btnToggle.setAttribute('aria-label', 'Video abspielen');
    });
    v.addEventListener('ended', function () {
      self.setProgress(self.index, 1);
      if (self.items.length === 1) { v.currentTime = 0; self.play(); return; }
      self.go(self.index + 1, { play: true });
    });
    v.addEventListener('volumechange', function () { self.updateMuteLabel(); });
    v.addEventListener('error', function () {
      v.classList.remove('is-ready');
      root.classList.remove('is-playing');
      /* 720p nicht vorhanden: einmalig auf 1080p zurückfallen */
      var item = self.items[self.index];
      var cur = v.currentSrc || '';
      if (item && self.mode === 'teaser' && cur.indexOf('.webm') > -1 && !item.__webmFailed) {
        item.__webmFailed = true;
        self.loaded = -1;
        if (self.visible && !self.userPaused) self.play(); else self.load(self.index);
        return;
      }
      if (item && !item.__sdFailed && v.currentSrc && v.currentSrc.indexOf('720p') > -1) {
        item.__sdFailed = true;
        self.loaded = -1;
        if (self.visible && !self.userPaused) self.play(); else self.load(self.index);
      }
    });

    this.items.forEach(function (el, k) {
      el.addEventListener('click', function () {
        self.userPaused = false;
        self.go(k, { play: true, scroll: true });
      });
    });

    var q = function (sel) { return root.querySelector(sel); };
    q('[data-vh-next]') && q('[data-vh-next]').addEventListener('click', function () { self.userPaused = false; self.go(self.index + 1, { play: true }); });
    q('[data-vh-prev]') && q('[data-vh-prev]').addEventListener('click', function () { self.userPaused = false; self.go(self.index - 1, { play: true }); });
    q('[data-vh-sound-play]') && q('[data-vh-sound-play]').addEventListener('click', function () { self.startWithSound(); });
    q('[data-vh-fs]') && q('[data-vh-fs]').addEventListener('click', function () { self.fullscreen(); });
    q('[data-vh-fs-close]') && q('[data-vh-fs-close]').addEventListener('click', function (e) {
      e.stopPropagation();
      var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (fsEl) (document.exitFullscreen || document.webkitExitFullscreen).call(document);
    });
    function onFs() {
      var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      var on = fsEl === self.stage;
      self.stage.classList.toggle('is-fs', on);
      if (on) { var c = q('[data-vh-fs-close]'); if (c) c.focus({ preventScroll: true }); return; }
      if (self.fsMode) {
        /* Vollbild verlassen: zurück zur stummen Vorschau */
        self.fsMode = false;
        v.muted = true;
        self.setMode('teaser');
        self.video.classList.remove('is-ready');
        if (self.visible && !self.userPaused && self.autoplay) self.play();
        else { v.pause(); v.removeAttribute('src'); v.load(); }
      }
    }
    document.addEventListener('fullscreenchange', onFs);
    document.addEventListener('webkitfullscreenchange', onFs);
    v.addEventListener('webkitendfullscreen', function () { onFs(); });

    function toggle() {
      if (v.paused) { self.userPaused = false; self.play(); }
      else { self.userPaused = true; self.pause(); }
    }
    this.btnToggle && this.btnToggle.addEventListener('click', toggle);
    this.media.addEventListener('click', toggle);

    this.btnMute && this.btnMute.addEventListener('click', function () {
      if (v.muted) {
        /* Vorschau-Clips haben keinen Ton: auf das ganze Video wechseln */
        self.startWithSound();
      } else {
        v.muted = true;
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { if (e.target.closest('[data-vh-list]')) { e.preventDefault(); self.go(self.index + 1, { play: !v.paused }); self.items[self.index].focus(); } }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { if (e.target.closest('[data-vh-list]')) { e.preventDefault(); self.go(self.index - 1, { play: !v.paused }); self.items[self.index].focus(); } }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && !v.paused) { self.hiddenPause = true; v.pause(); }
      else if (!document.hidden && self.hiddenPause) { self.hiddenPause = false; if (self.visible && !self.userPaused) self.play(); }
    });

    /* a11y (Claude, 2026-09-28): Panel-Schalter 'Bewegung stoppen' – automatische Vorschau anhalten */
    document.addEventListener('bek:reduce-motion', function (e) {
      if (e && e.detail && e.detail.on) {
        reduceMotion = true;
        self.autoplay = false;
        if (!self.userStarted && !v.paused) v.pause();
      } else {
        reduceMotion = false;
        self.autoplay = root.getAttribute('data-autoplay') === 'true' && !saveData;
        if (self.autoplay && self.visible && v.paused && !self.userPaused) self.play();
      }
    });

    /* Theme-Editor: gewählten Block anzeigen */
    document.addEventListener('shopify:block:select', function (e) {
      var k = self.items.indexOf(e.target);
      if (k > -1) self.go(k, { play: false });
    });
  };

  VideoHero.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this.visible = true;
      if (this.autoplay) this.play();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        self.visible = en.isIntersecting && en.intersectionRatio > 0.25;
        var v = self.video;
        if (self.visible) {
          if (v.paused && !self.userPaused && (self.autoplay || self.userStarted)) self.play();
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.25, 0.5] });
    io.observe(this.root);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-bek-vh]').forEach(function (el) {
      if (el.__bekVh) return;
      el.__bekVh = new VideoHero(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
